import { render, staticRenderFns } from "./LoginIndex.vue?vue&type=template&id=cb548934&scoped=true&"
import script from "./LoginIndex.vue?vue&type=script&lang=js&"
export * from "./LoginIndex.vue?vue&type=script&lang=js&"
import style0 from "./LoginIndex.vue?vue&type=style&index=0&id=cb548934&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb548934",
  null
  
)

export default component.exports